import { Model } from '@/app/shared/models/model';
import { BillingMode, PaymentMethod } from '../../enums';

export class RefundSettingsModel extends Model {
  public BillingMode!: BillingMode;
  public PaymentMethod!: PaymentMethod;
  public Term?: string;
  public Account!: string;
  public AutomaticApproval!: boolean;
  public ConfigurationMessage?: string;
}
